import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <>
            <footer className="footer footer-1">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <div className="footer-widget widget-contact">
                                    <div className="footer-widget-title">
                                        <h3>quick contact</h3>
                                    </div>
                                    <div className="widget-content">
                                        <p>If you have any questions or need help, feel free to contact with our team.</p>
                                        <ul>
                                            <li className="phone"><a href="tel:(+91)9454311900"><i className="fas fa-phone-alt"></i>(+91) 9454311900</a></li>
                                            <li className="address"><a href="#">
                                                Mishra Sadan , 26A/13 C Muir Road, Saraswatipuram Colony, Rajapur ( Beside Chandra Guest House), Prayagraj(UP)-211002</a></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <!--  End .col-lg-3--> */}
                            </div>
                            <div className="col-sm-6 col-md-3 col-lg-2 offset-lg-0">
                                <div className="footer-widget widget-links">
                                    <div className="footer-widget-title">
                                        <h3>company</h3>
                                    </div>
                                    <div className="widget-content">
                                        <ul>
                                            <li><Link to="/">Home Page</Link></li>
                                            <li><Link to="/About-Us">About Us</Link></li>
                                            <li><Link to="/Our-Clients">Our Clients</Link></li>

                                            {/* <li><a href="page-team.html">Leadership Team</a></li>
                                            <li><a href="blog-grid-fullwidth.html">News & Media</a></li>
                                            <li><a href="page-how-it-works.html">How it Works</a></li> */}
                                            <li><Link to="/Gallery">Gallery</Link></li>
                                            <li><Link to="/Contact-Us">Contacts</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* <!--  End .col-lg-2--> */}
                            <div className="col-sm-6 col-md-3 col-lg-2">
                                <div className="footer-widget widget-links">
                                    <div className="footer-widget-title">
                                        <h3>our services</h3>
                                    </div>
                                    <div className="widget-content">
                                        <ul>
                                            <li><Link to="/Octopuss-Jobs">Octopuss Jobs</Link></li>
                                            <li><Link to="/Octopuss-Technologies">Octopuss Technologies</Link></li>
                                            <li><Link to="/Octopuss-Events">Octopuss Events</Link></li>
                                            <li><Link to="/Octopuss-Retails">Octopuss Retails</Link></li>
                                            <li><Link to="/Octopuss-Infratructure">Octopuss Infratructure</Link></li>
                                            <li><Link to="/Octopuss-Security">Octopuss Security</Link></li>
                                            <li><Link to="/Facility-Management-System">Facility-Management-System</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* <!--  End .col-lg-2--> */}
                            {/* <div className="col-sm-6 col-md-4 col-lg-2 offset-lg-0">
                                <div className="footer-widget widget-links">
                                    <div className="footer-widget-title">
                                        <h3>support</h3>
                                    </div>
                                    <div className="widget-content">
                                        <ul>
                                            <li><a href="page-contact.html">Become a Franchise</a></li>
                                            <li><a href="page-contact.html">Terms & Conditions</a></li>
                                            <li><a href="blog-grid-fullwidth.html">Cleaning Tips</a></li>
                                            <li><a href="shop-products.html">Products</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!--  End .col-lg-2--> */}
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="footer-widget widget-newsletter">
                                    <div className="widget-content"><a className="btn btn--alternative">Made2klean</a>
                                        {/* <!-- Start .module-social--> */}
                                        <div className="module module-social"><a className="share-facebook" href="#"><i className="fab fa-facebook-f"> </i></a><a className="share-instagram" href="#"><i className="fab fa-instagram"></i></a><a className="share-twitter" href="#"><i className="fab fa-twitter"></i></a></div>
                                        {/* <!-- End .module-social--> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--  End .container--> */}
                </div>
                {/* <!--  End .footer-center--> */}
                <div className="footer-bottom">
                    <div className="container">
                        <div className="footer-copyright">
                            <div className="copyright-holder">
                                <div className="copyright"><span>&copy; Copyright Awadh Web Solutions Pvt. Ltd. 2026. All rights reserved </span></div>

                            </div>

                        </div>
                    </div>
                    {/* <!--  End .row--> */}
                </div>
                {/* <!--  End .footer-bottom--> */}
            </footer>
        </>
    )
}

export default Footer;